interface ActivationEmailParams {
    nickname?: string;
    activationLink: string;
    supportEmail?: string;
    appName?: string;
}

const escapeHtml = (value: string): string => {
    return value.replace(/[&<>'"`]/g, char => {
        switch (char) {
            case '&':
                return '&amp;';
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            case '"':
                return '&quot;';
            case `'`:
                return '&#39;';
            case '`':
                return '&#96;';
            default:
                return char;
        }
    });
};

export const buildActivationEmail = ({
    nickname,
    activationLink,
    supportEmail = `${process.env.REACT_APP_SUPORT_EMAIL || ''}`,
    appName = 'Ciclii',
}: ActivationEmailParams): string => {
    const safeName = nickname ? escapeHtml(nickname.trim()) : '';
    const trimmedLink = activationLink.trim();
    const safeLink = trimmedLink ? escapeHtml(trimmedLink) : '#';
    const safeSupportEmail = escapeHtml(supportEmail.trim());
    const safeAppName = escapeHtml(appName.trim());
    const greeting = safeName ? `¡Hola ${safeName}!` : '¡Hola!';
    const headline = `¡Estás a un paso de activar tu cuenta en ${safeAppName}!`;
    const pageTitle = `Activa tu cuenta en ${safeAppName}`;
    // const fallbackSection = trimmedLink
    //     ? `<p style="margin:0 0 16px;font-size:15px;line-height:1.6;color:#5d5774;">Si el botón no funciona, copia y pega este enlace en tu navegador:</p>
    //             <p style="margin:0 0 24px;font-size:15px;line-height:1.6;word-break:break-all;">
    //                 <a href="${safeLink}" style="color:#6b3fa0;font-weight:600;text-decoration:none;">${safeLink}</a>
    //             </p>`
    //     : '';
    const buttonLabel = 'Activar mi cuenta';

    return `<!DOCTYPE html>
<html lang="es">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>${pageTitle}</title>
    </head>
    <body style="margin:0;padding:0;background-color:#f5f5fb;font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:#2d2a44;">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:#f5f5fb;padding:40px 16px;">
            <tr>
                <td align="center">
                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:600px;background-color:#ffffff;border-radius:20px;overflow:hidden;border:1px solid rgba(181,126,220,0.45);box-shadow:0 12px 32px rgba(181,126,220,0.2);">
                        <tr>
                            <td style="background:linear-gradient(135deg,#B67FDC 0%,#b57edc 65%,#d8bfd8 100%);padding:32px 24px;text-align:center;">
                                <h1 style="margin:0;font-size:26px;line-height:1.35;color:#ffffff;font-weight:700;font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif;">${headline}</h1>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding:32px 24px;">
                                <p style="margin:0 0 16px;font-size:16px;line-height:1.6;">${greeting}</p>
                                <p style="margin:0 0 16px;font-size:16px;line-height:1.6;">Confirmar tu correo nos permite proteger tu cuenta y darte acceso a todo el contenido personalizado sobre tu ciclo.</p>
                                <p style="margin:0 0 24px;font-size:16px;line-height:1.6;">Haz clic en el botón para activar tu cuenta ahora mismo:</p>
                                <p style="margin:0 0 32px;text-align:center;">
                                    <a href="${safeLink}" style="display:inline-block;padding:16px 28px;border-radius:999px;background:linear-gradient(135deg,#B67FDC 0%,#b57edc 65%,#d8bfd8 100%);color:#ffffff;font-weight:600;font-size:16px;text-decoration:none;box-shadow:0 10px 24px rgba(118,75,162,0.3);">${buttonLabel}</a>
                                </p>
                                <p style="margin:0;font-size:15px;line-height:1.6;color:#5d5774;">¿Necesitas ayuda? Escríbenos a <a href="mailto:${safeSupportEmail}" style="color:#764ba2;text-decoration:none;font-weight:600;">${safeSupportEmail}</a>.</p>
                            </td>
                        </tr>
                        <tr>
                            <td style="background-color:#f7f5ff;padding:24px;text-align:center;color:#8379a3;font-size:13px;line-height:1.5;">
                                <p style="margin:0;">Recibes este correo porque te registraste en ${safeAppName}.</p>
                                <p style="margin:8px 0 0;">Mantente al tanto para descubrir tips, recursos y herramientas hechas para ti.</p>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </body>
</html>`;
};

export type { ActivationEmailParams };

